import { render } from "./Key1.vue?vue&type=template&id=3f2e8e88"
import script from "./Key1.vue?vue&type=script&lang=ts"
export * from "./Key1.vue?vue&type=script&lang=ts"
script.render = render

export default script